import React from "react";
import Icon from "../../../common/Icon";
import Select from "../../../common/Select";
import Button from "../../../common/Button";
import memoizeOne from "memoize-one";
import connectToMedia from "../../Media/connectToMedia";
import { difference, get } from "lodash";
import { isEmpty } from "lodash";

const searchTranscript = (term, transcript) => {
  return transcript.reduce((acc, word, i, words) => {
    const termWords = term.split(" "); // query.match(/(\w+'\w+)|\w+|,|\.|!|\?/g);
    const wordsMatch = termWords.every((qWord, j) => {
      // Check if words match raw
      if (
        words[i + j] &&
        qWord.toLowerCase() === words[i + j].w.toLowerCase()
        // || words[i + j].w.toLowerCase().includes(qWord.toLowerCase())
      ) {
        return true;
      }

      // If this word is punctation, and the last ends in it, ignore it.
      if (
        words[i + j] &&
        words[i + j].m === "punc" &&
        qWord[i - 1] &&
        words[i + j].w === qWord.charAt(qWord.length - 1)
      ) {
        return true;
      }

      // Otherwise, match if the next word is punctuation and the last character matches it.
      if (
        words[i + j + 1] &&
        words[i + j + 1].m === "punc" &&
        qWord.substr(0, qWord.length - 1).toLowerCase() ===
          words[i + j].w.toLowerCase() &&
        words[i + j + 1].w === qWord.charAt(qWord.length - 1)
      ) {
        return true;
      }
    });

    // Pass word position for more accurate highlight animation
    if (wordsMatch) {
      acc.push({ s: word.s, p: word.p });
    }

    return acc;
  }, []);
};

class Index extends React.PureComponent {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      hitIndex: 0,
      closeColor: "#677791",
    };
  }
  getSearchQueryValues = memoizeOne((queries) =>
    queries
      .filter((query) => query.type === "search")
      .map((query) => query.parent)
  );

  getSearchQueryHits = memoizeOne(({ queries, reverse = false }) => {
    return []
      .concat(
        ...queries
          .filter((query) => query.type === "search")
          .map((query) => query.hits)
      )
      .sort((a, b) => {
        if (reverse) {
          return a.s > b.s ? -1 : 1;
        }
        return a.s < b.s ? -1 : 1;
      });
  });

  skipToNextHit = (event) => {
    const { queries, currentTime, currentPosition, onSeek, onSkipPrevNextHit } =
      this.props;
    const searchQueryHits = this.getSearchQueryHits({ queries });
    // Check hit by position for more accurate positioning
    const hit =
      searchQueryHits.find((hit) => hit.p > Math.ceil(currentPosition)) ||
      searchQueryHits[0];

    if (hit) {
      onSeek(hit);
      onSkipPrevNextHit(true);
    }
  };

  skipToPrevHit = (event) => {
    const { queries, currentTime, currentPosition, onSeek, onSkipPrevNextHit } =
      this.props;

    const searchQueryHits = this.getSearchQueryHits({ queries, reverse: true });

    // Check hit by position for more accurate positioning
    const hit =
      searchQueryHits.find((hit) => hit.p < Math.floor(currentPosition)) ||
      searchQueryHits[0];

    if (hit) {
      onSeek(hit);
      onSkipPrevNextHit(true);
    }
  };

  onChange = (newSearchValuesArr) => {
    const newSearchValues = newSearchValuesArr.map((val) => val.trim());
    const { onRemoveQuery, onAddQuery, queries = [], transcript, onSeek, currentPosition } = this.props;
    const searchValues = this.getSearchQueryValues(queries);
    this.setState({
      searchValue: newSearchValues,
    });
    difference(newSearchValues, searchValues).forEach((value) => {
      onAddQuery({
        parent: value,
        hits: searchTranscript(value, transcript),
        label: value,
        icon: "search",
        type: "search",
      });
      const searchQueryHits = this.getSearchQueryHits({
        queries: [
          {
            parent: value,
            hits: searchTranscript(value, transcript),
            label: value,
            icon: "search",
            type: "search",
          },
        ],
        reverse: true,
      });

      // Check hit by position for more accurate positioning
      const hit =
        searchQueryHits.find((hit) => hit.p < Math.floor(currentPosition)) ||
        searchQueryHits[0];
      if (hit) {
        onSeek(hit);
      }
    });

    difference(searchValues, newSearchValues).forEach((value) => {
      onRemoveQuery(value);
    });
  };
  onRemove = () => {
    const { onRemoveQuery, onAddQuery, queries = [], transcript } = this.props;
    const searchValues = this.getSearchQueryValues(queries);
    this.setState({
      searchValue: "",
    });
    difference([], searchValues).forEach((value) => {
      onAddQuery({
        parent: value,
        hits: searchTranscript(value, transcript),
        label: value,
        icon: "search",
        type: "search",
      });
    });

    difference(searchValues, []).forEach((value) => {
      onRemoveQuery(value);
    });
    this.setState({ hitIndex: 0 });
  };

  render() {
    const { queries = [] } = this.props;
    const searchValues = this.getSearchQueryValues(queries);

    const hitCount = queries.reduce(
      (acc, query) => get(query, "hits.length", 0) + acc,
      0
    );
    return (
      <div
        style={{
          paddingLeft: "10px",
          paddingBottom: "25px",
          background: "rgb(255, 255, 255)",
          flex: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "none",
            alignItems: "center",
            background: "#f0f1f4",
          }}
          className="search-input-container"
        >
          <div id="search-field" style={{ padding: "0 0px", width: "80%" }}>
            <Select
              size="small"
              style={{ width: "100%" }}
              dropdownStyle={{ display: "none" }}
              tags
              tokenSeparators={["|"]}
              suffixIcon={<Icon type="search" />}
              placeholder="Find words in the transcript"
              defaultValue={searchValues}
              onChange={this.onChange}
              value={searchValues}
              showSearch={true}
            />
            {/* {this.setPanelsIcon(PanelName.KeyWord)}
                <S.SearchInput placeholder="Search"></S.SearchInput> */}
            {/* <input
              type="search"
              onChange={this.onChange}
              value={this.state.searchValue}
              id="header-search"
              style={{
                width: "100%",
                borderBottomRightRadius: !isEmpty(this.state.searchValue)
                  ? "0px"
                  : "8px",
                borderTopRightRadius: !isEmpty(this.state.searchValue)
                  ? "0px"
                  : "8px",
              }}
              placeholder="Search transcript"
            />
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.13379 16.5439C12.7582 16.5439 15.6963 13.6058 15.6963 9.98145C15.6963 6.35708 12.7582 3.41895 9.13379 3.41895C5.50942 3.41895 2.57129 6.35708 2.57129 9.98145C2.57129 13.6058 5.50942 16.5439 9.13379 16.5439Z"
                stroke="#677791"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.7739 14.6221L17.5708 18.419"
                stroke="#677791"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg> */}
            {/* <span className="hit-count">
              {!isEmpty(this.state.searchValue) &&
                this.state.hitIndex + "/" + hitCount}
            </span> */}
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.13379 16.5439C12.7582 16.5439 15.6963 13.6058 15.6963 9.98145C15.6963 6.35708 12.7582 3.41895 9.13379 3.41895C5.50942 3.41895 2.57129 6.35708 2.57129 9.98145C2.57129 13.6058 5.50942 16.5439 9.13379 16.5439Z"
                stroke="#677791"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.7739 14.6221L17.5708 18.419"
                stroke="#677791"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div style={{ flex: "none" }}>
            {!isEmpty(this.state.searchValue) && (
              // <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              // <path d="M3 10L8 5L13 10" stroke="#677791" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              // </svg>

              <Button
                shape="none"
                size="sm"
                onClick={this.skipToPrevHit}
                icon="up"
                disabled={hitCount == 0}
                style={{
                  border: "none",
                  height: "32px",
                  marginTop: "1px",
                  borderRadius: "0px",
                  background: "#f0f1f4",
                }}
              />
            )}
          </div>
          <div style={{ padding: "0 0px", flex: "none" }}>
            {!isEmpty(this.state.searchValue) && (
              <Button
                shape="none"
                size="sm"
                onClick={this.skipToNextHit}
                icon="down"
                disabled={hitCount == 0}
                style={{
                  border: "none",
                  height: "32px",
                  marginTop: "1px",
                  background: "#f0f1f4",
                  borderRadius: "0px",
                }}
              />
            )}
          </div>
          <div
            style={{ padding: "0 0px", flex: "none" }}
            className="close-content"
          >
            {!isEmpty(this.state.searchValue) && (
              //   <Button
              //     shape="none"
              //     size="sm"
              //     onClick={this.skipToNextHit}
              //     icon="down"
              //     disabled={hitCount == 0}

              //   />
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="close-icon"
                onClick={() => this.onRemove()}
                onMouseOver={() => this.setState({ closeColor: "#262D38" })}
                onMouseLeave={() => this.setState({ closeColor: "#677791" })}
              >
                <path
                  d="M12.5 3.5L3.5 12.5"
                  stroke={this.state.closeColor}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.5 12.5L3.5 3.5"
                  stroke={this.state.closeColor}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connectToMedia((state) => {
  return {
    currentTime: state.media.currentTime,
    currentPosition: state.media.currentPosition,
    skipPrevNextHit: state.media.skipPrevNextHit,

    queries: state.query,
  };
})(Index);
